import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class TranslationLoaderResolver {

  constructor(private translate: TranslateService) {
  }

  resolve(): Observable<any> {
    return this.translate.get('dummy');
  }

}
